import { styled, Typography } from '@mui/material';
export const DateText = styled(Typography)`
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  text-align: right;
  letter-spacing: 2px;
`;
